import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import { fetchCultures } from '_redux/actioncreators/cultures';

import Loader from './general/Loader';
import App from './App';

class CultureRouter extends Component {
  constructor(props) {
    super(props);

    props.fetchCultures();
  }

  render() {
    if (this.props.cultures.contentLoading === true) {
      return <Loader />;
    }

    const defaultCulture = this.props.cultures.content.cultureItems.find(x => x.isDefaultCulture === true);

    return (
      <Router>
        <Switch>
          {this.props.cultures.content.cultureItems.map(this.renderRoute)}
          <Redirect to={`/${defaultCulture.alias}/`}></Redirect>
        </Switch>
      </Router>
    );
  }

  // eslint-disable-next-line
  renderRoute(item, index) {
    return <Route key={index} path={`/${item.alias}/`} component={() => <App culture={item} />}></Route>;
  }
}

const mapStateToProps = state => ({
  cultures: state.app.cultures,
});

const mapDispatchToProps = dispatch => ({
  fetchCultures: params => dispatch(fetchCultures(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CultureRouter);
